<template>
    <div style="cursor: pointer;" class="catCard w-25 p-2">
    <div
      class="py-4 px-2 h-100 border-0 rounded d-flex flex-column justify-content-start align-items-center" :class="selected.id == category.id? 'btn-success' : 'btn-primary'"
      @click="selectCat(category)">

      <div>
        <i class="d-none d-sm-block" :class="category.acf.icon"></i>
      </div>
      <span v-html="category.name"></span>
    </div>
  </div>
</template>
<script>


export default {

    props: { category: { type: Object }, selectCat: { type: Function }, selected: {type: Object} },
}
</script>